import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.questionHistory.loading;
export const selectErrorMessage = (state: RootState) =>
  state.messageHistoryList.error;
export const sendQuestionHistoryDataResponse = (state: RootState) =>
  state.questionHistory.questionHistoryResponse;
